/**
 * 贷款更新
 */
import React, { useEffect, useRef } from 'react';
import { ConfigProvider, Modal } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import { isEmpty } from 'lodash-es';
import track, { numFormat } from '../utils.ts';
import {SFuncModal, SGeneralForms} from "shj-components";
export function modalBindingKuklerSchemesDetailsModelFn(props: any) {
  const { onClose, fn, ...rest } = props;
  const { flag, msg } = rest;
  if (flag == true) {
    Modal.info({
      title: '方案详情',
      content: msg,
      onOk() {},
      okText: '是',
    });
  } else {
    if (!isEmpty(rest.trackParams)) {
      track('task_page_view', {
        enter_time: moment().format('yyyy-MM-DD HH:mm:ss.SSS'),
        ...rest.trackParams,
      });
    }
    const onClose = () => {
      if (!isEmpty(rest.trackParams)) {
        track('task_page_close', {
          leave_time: moment().format('yyyy-MM-DD HH:mm:ss.SSS'),
          ...rest.trackParams,
        });
      }
      dialog.destroy();
    };

    const dialog = SFuncModal({
      title: `方案详情`,
      getContainer: false,
      vanish: true,
      onCancel: () => {
        onClose();
      },
      content: (
        <ConfigProvider locale={zhCN}>
          <ModalBindingKuklerSchemesDetailsModelDom onClose={onClose} fn={fn} {...rest} msg={msg} />
        </ConfigProvider>
      ),
    });

    return dialog;
  }
}

export const ModalBindingKuklerSchemesDetailsModelDom = (props: any) => {
  const { onClose, fn, ...rest } = props;
  const { nowDetails } = rest;
  const baseFormRef = useRef();
  const ininFn = () => {
    baseFormRef?.current?.onFormRef()?.setFieldsValue({ ...nowDetails });
  };

  useEffect(() => {
    ininFn();
  }, [nowDetails]);
  return (
    <div>
      <SGeneralForms
        ref={baseFormRef}
        isDetail={true}
        isFooterBtn={false}
        configs={[
          {
            formItem: [
              {
                name: 'id',
                label: '方案ID',
                spanCol: 12,
                children: (
                  <div style={{ marginLeft: 15, color: '#333' }}>
                    {nowDetails.id || nowDetails.designId || nowDetails.planId}
                  </div>
                ),
              },
              {
                name: 'customerName',
                label: '方案阶段',
                spanCol: 12,
                children: (
                  <div style={{ marginLeft: 15, color: '#333' }}>{!nowDetails.designId ? '装修阶段' : '设计阶段'}</div>
                ),
              },
              {
                name: 'commName',
                label: '小区',
                spanCol: 12,
              },
              {
                name: 'city',
                label: '城市',
                spanCol: 12,
              },
              {
                name: 'name',
                label: '方案名称',
                spanCol: 12,
              },
              {
                name: 'area',
                label: '建筑面积',
                spanCol: 12,
                children: (
                  <div style={{ marginLeft: 15, color: '#333' }}>
                    {nowDetails?.area ? numFormat({ value: nowDetails.area }) : ''}
                  </div>
                ),
              },
              {
                name: 'specName',
                label: '套内面积',
                spanCol: 12,
              },
              {
                name: 'desc',
                spanCol: 24,
                label: '方案描述',
              },
              {
                name: 'planPic',
                spanCol: 24,
                label: '展示图片',
                children: () => {
                  return (
                    <div>
                      <img
                        style={{ maxWidth: 124, maxHeight: 124 }}
                        src={nowDetails.planPic || nowDetails.coverPic}
                        alt={''}
                      />
                    </div>
                  );
                },
              },
            ],
          },
        ]}
      />
    </div>
  );
};
